export default __webpack_public_path__ + "static/media/design-pattern-library.357cefa4.svg";